export default __webpack_public_path__ + "static/media/HoverSetting2.3483977e.png";